import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_SERVICE_TYPE_LISTING,
    GET_SERVICE_TYPE_DETAILS,
    ADD_SERVICE_TYPE,
    UPDATE_SERVICE_TYPE,
    DELETE_SERVICE_TYPE,
    BULK_DELETE_SERVICE_TYPE,
    EXPORT_SERVICE_TYPE,
} from "./actionTypes.js";

import {
    getServiceTypeListingSuccess,
    getServiceTypeListingFail,
    createServiceTypeSuccess,
    createServiceTypeFail,
    updateServiceTypeSuccess,
    updateServiceTypeFail,
    deleteServiceTypeSuccess,
    deleteServiceTypeFail,
    bulkDeleteServiceTypeSuccess,
    bulkDeleteServiceTypeFail,
    exportServiceTypeSuccess,
    exportServiceTypeFail,
    getServiceTypeDetailsSuccess,
    getServiceTypeDetailsFail,
} from "./actions.js";

import {
    serviceTypeListingApi,
    updateServiceTypeApi,
    deleteServiceTypeApi,
    bulkDeleteServiceTypeApi,
    exportServiceTypeApi,
    serviceTypeDetailsApi,
    addServiceTypeApi,
} from "./serviceTypeApi.js";

function* fetchServiceTypeListing({ payload }) {
    try {
        const response = yield call(serviceTypeListingApi, payload);
        yield put(getServiceTypeListingSuccess(response));
    } catch (error) {
        yield put(getServiceTypeListingFail(error));
    }
}

function* fetchServiceTypeDetail({ payload }) {
    try {
        const response = yield call(serviceTypeDetailsApi, payload);
        yield put(getServiceTypeDetailsSuccess(response));
    } catch (error) {
        yield put(getServiceTypeDetailsFail(error));
    }
}

function* createServiceType({ payload }) {
    try {
        const response = yield call(addServiceTypeApi, payload);
        yield put(createServiceTypeSuccess(response));
    } catch (error) {
        yield put(createServiceTypeFail(error));
    }
}

function* updateServiceType({ payload }) {
    try {
        const response = yield call(updateServiceTypeApi, payload);
        yield put(updateServiceTypeSuccess(response));
    } catch (error) {
        yield put(updateServiceTypeFail(error));
    }
}

function* deleteServiceType({ payload }) {
    try {
        const response = yield call(deleteServiceTypeApi, payload);
        yield put(deleteServiceTypeSuccess(response));
    } catch (error) {
        yield put(deleteServiceTypeFail(error));
    }
}

function* bulkDeleteServiceType({ payload }) {
    try {
        const response = yield call(bulkDeleteServiceTypeApi, payload);
        yield put(bulkDeleteServiceTypeSuccess(response));
    } catch (error) {
        yield put(bulkDeleteServiceTypeFail(error));
    }
}

function* exportServiceType({ payload }) {
    try {
        const response = yield call(exportServiceTypeApi, payload);
        yield put(exportServiceTypeSuccess(response));
    } catch (error) {
        yield put(exportServiceTypeFail(error));
    }
}

function* ServiceTypeSaga() {
    yield takeEvery(GET_SERVICE_TYPE_LISTING, fetchServiceTypeListing);
    yield takeEvery(GET_SERVICE_TYPE_DETAILS, fetchServiceTypeDetail);
    yield takeEvery(ADD_SERVICE_TYPE, createServiceType);
    yield takeEvery(UPDATE_SERVICE_TYPE, updateServiceType);
    yield takeEvery(DELETE_SERVICE_TYPE, deleteServiceType);
    yield takeEvery(BULK_DELETE_SERVICE_TYPE, bulkDeleteServiceType);
    yield takeEvery(EXPORT_SERVICE_TYPE, exportServiceType);

}

export default ServiceTypeSaga
